exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-navigating-the-challenges-of-monetizing-your-website-js": () => import("./../../../src/pages/navigating-the-challenges-of-monetizing-your-website.js" /* webpackChunkName: "component---src-pages-navigating-the-challenges-of-monetizing-your-website-js" */)
}

